export default function ContractRenewals() {
  return (
    <div className="animate-slide-up">
      <div className="page-header">
        <h1 className="page-title">Contract Renewals</h1>
        <p className="page-subtitle">Track and manage upcoming contract renewals.</p>
      </div>
      <p className="text-muted-foreground">Coming soon.</p>
    </div>
  );
}
